<template>
<div v-if="info.nid === '26'" class="">
    <PageBreadcrumb :pagetitle="info.title"/>
    <!-- About -->
    <section class="aboutsec py-5">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-5 mb-4 mb-md-0">
                    <div class="aboutimg">
                        <img v-bind:src="info.field_image" class="img-fluid rounded" alt="" />
                    </div>
                </div>
                <div class="col-12 col-md-7">
                    <div class="heading">
                        <h2>Welcome Forward In Faith Ministries </h2>
                        <hr class="brd-primary ml-0">
                    </div>
                    <p class="text-justify" v-html="info.body" ></p>
                </div>
            </div>
        </div>
    </section>
    <!-- End About -->
    <!-- Choose -->
    <section class="choosesec bg-cover" :style="{'background-image': 'url(' + require('../assets/images/bg1.jpg') + ')'}">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-12 mb-4">
                    <div class="heading text-center">
                        <h2 class="text-white">About Our Ministry</h2>
                        <hr class="brd-white">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-3" v-if="founderone.nid === '6'">
                    <div class="choose-block text-center rounded">
                        <div class="choose-image">
                            <img v-bind:src="founderone.field_basic_image" class="img-fluid" alt="">
                        </div>
                        <div class="choose-content">
                            <h6><span v-bind:data-hover="founderone.title">{{ founderone.title }}</span></h6>
                            <p class="mb-0" v-html="founderone.body_1"></p>
                            <router-link :to="founderone.view_node"><u>Read More <i class="icofont icofont-double-right"></i></u></router-link>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-3" v-if="foundertwo.nid === '5'">
                    <div class="choose-block text-center rounded">
                        <div class="choose-image">
                            <img v-bind:src="foundertwo.field_basic_image" class="img-fluid" alt="">
                        </div>
                        <div class="choose-content">
                            <h6><span v-bind:data-hover="foundertwo.title">{{ foundertwo.title }}</span></h6>
                            <p class="mb-0" v-html="foundertwo.body_1"></p>
                            <router-link :to="foundertwo.view_node"><u>Read More <i class="icofont icofont-double-right"></i></u></router-link>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-3" v-if="pastors.nid === '139'">
                    <div class="choose-block text-center rounded">
                        <div class="choose-image">
                            <img v-bind:src="pastors.field_basic_image" class="img-fluid" alt="">
                        </div>
                        <div class="choose-content">
                            <h6><span v-bind:data-hover="pastors.title">{{ pastors.title }}</span></h6>
                            <p class="mb-0" v-html="pastors.body_1"></p>
                            <router-link :to="pastors.view_node"><u>Read More <i class="icofont icofont-double-right"></i></u></router-link>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-3" v-if="history.nid === '4'">
                    <div class="choose-block text-center rounded">
                        <div class="choose-image">
                            <img v-bind:src="history.field_basic_image" class="img-fluid" alt="">
                        </div>
                        <div class="choose-content">
                            <h6><span v-bind:data-hover="history.title">{{ history.title }}</span></h6>
                            <p class="mb-0" v-html="history.body_1"></p>
                            <router-link :to="history.view_node"><u>Read More <i class="icofont icofont-double-right"></i></u></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>


<script>
import axios from 'axios';
import PageBreadcrumb from '@/components/PageBreadcrumb'

export default{
    name: 'About',
    data () {
        return {
            info: null,
            founderone: null,
            foundertwo: null,
            pastors: null,
            history: null
        }
    },
    components:{
        PageBreadcrumb
    },
    mounted () {
        axios
        .get('https://api.fifmi.org.au/api/about')
        .then(result => {
            for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].nid == 26){
                    this.info = result.data[i];
                }

                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].nid == 6){
                    result.data[i].view_node = result.data[i].view_node.match(/href="([^"]*)/)[1];
                    result.data[i].view_node = result.data[i].view_node.split('/').pop();
                    this.founderone = result.data[i];
                }

                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].nid == 5){
                    result.data[i].view_node = result.data[i].view_node.match(/href="([^"]*)/)[1];
                    result.data[i].view_node = result.data[i].view_node.split('/').pop();
                    this.foundertwo = result.data[i];
                }

                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].nid == 139){
                    result.data[i].view_node = result.data[i].view_node.match(/href="([^"]*)/)[1];
                    result.data[i].view_node = result.data[i].view_node.split('/').pop();
                    this.pastors = result.data[i];
                }

                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].nid == 4){
                    result.data[i].view_node = result.data[i].view_node.match(/href="([^"]*)/)[1];
                    result.data[i].view_node = result.data[i].view_node.split('/').pop();
                    this.history = result.data[i];
                }
            }
        });
    }
}
</script>
